export const Cobweb = ({ className = "" }) => (
  <svg
    viewBox="0 0 100 100"
    className={className}
    fill="none"
    stroke="currentColor"
    aria-hidden="true"
    data-testid="cobweb-decoration"
  >
    <g strokeWidth="1" opacity="0.55">
      <path d="M0 0 L95 0" />
      <path d="M0 0 L70 30" />
      <path d="M0 0 L48 48" />
      <path d="M0 0 L30 70" />
      <path d="M0 0 L0 95" />
      <path d="M20 0 A20 20 0 0 1 0 20" />
      <path d="M45 0 A45 45 0 0 1 0 45" />
      <path d="M70 0 A70 70 0 0 1 0 70" />
    </g>
  </svg>
);
